import { Component, OnInit,EventEmitter,Output } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-weatherdata',
  templateUrl: './weatherdata.component.html',
  styleUrls: ['./weatherdata.component.scss']
})
export class WeatherdataComponent implements OnInit {
  selectedComponent: string;

  constructor(private router: Router) {
      this.selectedComponent = router.url.split("/")[1];
}
  @Output() openTaskManager = new EventEmitter<any>();

  ngOnInit() {
  //  console.log("inside weatherdata");
  }
 @Output() taskManagerOpened: EventEmitter<void> = new EventEmitter();

  // This method will be called when the button is clicked
  onClickTaskManager() {
    //  console.log("inside weatherdata new");

//     this.taskManagerOpened.emit();  // Emit event to parent
        this.openTaskManager.emit(true);


  }

}
